import { Injectable } from '@angular/core';
import {ParentService} from '../../pages/A2-utils/ParentClass/ParentService';
import {Http} from '@angular/http';
import {constant} from '../../app.constants';
import {Observable} from 'rxjs/Observable';
import {IDriver} from '../interfaces/driver.interface';

@Injectable()
export class DriverService extends ParentService {

  constructor(
    private _http: Http
  ) {
    super();
  }

  get (
    providerId?: number,
    filter?: string,
    showInactive?: boolean,
    providerDriverStatusId?: number
  ): Observable<IDriver[]> {
    let url = constant.DRIVER.MCT_DRIVER.LIST_BY_FILTER;
    url += showInactive ? `?showInactive=${showInactive}` : '?showInactive=false';
    url += filter ? `&filter=${filter}` : `&filter=`;
    url += providerId ? `&providerId=${providerId}` : '';
    url += providerDriverStatusId ? `&providerDriverStatusId=${providerDriverStatusId}` : '';
    return this._http.get(url, this.getHeader())
      .map(res => res.json());
  }
}



// WEBPACK FOOTER //
// ./src/app/core/services/driver.service.ts